const SHIPPING_NOTE = `
	<div class="tpt-shipping__info-note">
		<div class="tpt-shipping__info-note-icon">
			<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M6 0C9.3138 0 12 2.6862 12 6C12 9.3138 9.3138 12 6 12C2.6862 12 0 9.3138 0 6C0 2.6862 2.6862 0 6 0ZM5.994 4.8H5.4C5.24707 4.80017 5.09998 4.85873 4.98878 4.96371C4.87758 5.06869 4.81066 5.21217 4.8017 5.36484C4.79273 5.5175 4.8424 5.66783 4.94056 5.7851C5.03871 5.90237 5.17794 5.97774 5.3298 5.9958L5.4 6V8.994C5.4 9.306 5.6364 9.564 5.94 9.5964L6.006 9.6H6.3C6.42619 9.6 6.54916 9.56022 6.65144 9.48631C6.75372 9.4124 6.83009 9.30813 6.8697 9.18831C6.9093 9.0685 6.91012 8.93925 6.87204 8.81895C6.83397 8.69864 6.75893 8.59341 6.6576 8.5182L6.6 8.4804V5.406C6.6 5.094 6.3636 4.836 6.06 4.8036L5.994 4.8ZM6 3C5.84087 3 5.68826 3.06321 5.57574 3.17574C5.46321 3.28826 5.4 3.44087 5.4 3.6C5.4 3.75913 5.46321 3.91174 5.57574 4.02426C5.68826 4.13679 5.84087 4.2 6 4.2C6.15913 4.2 6.31174 4.13679 6.42426 4.02426C6.53679 3.91174 6.6 3.75913 6.6 3.6C6.6 3.44087 6.53679 3.28826 6.42426 3.17574C6.31174 3.06321 6.15913 3 6 3Z" fill="#A3A3A3"/>
			</svg>
		</div>

		<div class="tpt-shipping__info-note-content">${window.tptTrackOrder.shippingNote}</div>
	</div>
`;

const REFUND_LABEL = `
	<div class="tpt-refund__label">
		<ul>
			<li class="tpt-refund__label-process">
				<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="4.57115" cy="4.5731" r="3.42857" fill="#12283E"/>
				<circle cx="4.57129" cy="4.57227" r="4.28571" stroke="#12283E" stroke-width="0.571429"/>
				</svg>
				${window.tptTrackOrder.processing_refund}
			</li>

			<li class="tpt-refund__label-dash"></li>

			<li class="tpt-refund__label-completed">
				<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="4.57115" cy="4.5731" r="3.42857" fill="#12283E"/>
				<circle cx="4.57129" cy="4.57227" r="4.28571" stroke="#12283E" stroke-width="0.571429"/>
				</svg>
				${window.tptTrackOrder.refund_complete}
			</li>
		</ul>
	</div>
`;

// Confirmed - Failed Delivery - Returned
const returnProcessOne = `
<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8055" cy="11.8055" r="8.85437" fill="#D01345"/>
					<circle cx="11.8057" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"/>
					<path d="M14.8057 7.49902C14.9767 7.49902 15.1407 7.56669 15.2617 7.6875C15.3828 7.80857 15.4512 7.97331 15.4512 8.14453C15.4511 8.31572 15.3827 8.47954 15.2617 8.60059L12.3984 11.459L12.3818 11.4746L12.3984 11.4912L15.2617 14.3486V14.3496C15.322 14.4094 15.3707 14.4803 15.4033 14.5586C15.4359 14.6368 15.4521 14.7209 15.4521 14.8057C15.4521 14.8904 15.4359 14.9745 15.4033 15.0527C15.3707 15.1311 15.322 15.202 15.2617 15.2617C15.202 15.322 15.1311 15.3707 15.0527 15.4033C14.9745 15.4359 14.8904 15.4521 14.8057 15.4521C14.7209 15.4521 14.6368 15.4359 14.5586 15.4033C14.4803 15.3707 14.4094 15.322 14.3496 15.2617L11.4922 12.3975L11.4756 12.3809L11.459 12.3975L8.60156 15.2617C8.54181 15.322 8.47091 15.3707 8.39258 15.4033C8.31433 15.4359 8.23027 15.4521 8.14551 15.4521C8.06076 15.4521 7.97668 15.4359 7.89844 15.4033C7.82011 15.3707 7.74921 15.322 7.68945 15.2617C7.62921 15.202 7.58048 15.1311 7.54785 15.0527C7.51529 14.9745 7.49903 14.8904 7.49902 14.8057C7.49902 14.7209 7.51531 14.6368 7.54785 14.5586C7.58048 14.4803 7.62921 14.4094 7.68945 14.3496V14.3486L10.5527 11.4912L10.5693 11.4746L10.5527 11.459L7.68945 8.60059C7.56842 8.47954 7.50003 8.31572 7.5 8.14453C7.5 7.97331 7.5684 7.80857 7.68945 7.6875C7.81047 7.56669 7.97451 7.49902 8.14551 7.49902C8.31651 7.49903 8.48055 7.56668 8.60156 7.6875L11.459 10.5518L11.4756 10.5684L11.4922 10.5518L14.3496 7.6875C14.4706 7.56668 14.6347 7.49903 14.8057 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text" style="color: #D01345;">${window.tptTrackOrder.failed_delivery}</div>
			</li>


			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8055" cy="11.8055" r="8.85437" fill="#12283E"/>
					<circle cx="11.8057" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7142 8.42745C17.0743 8.82234 17.0526 9.4405 16.6659 9.80815L10.6841 15.4949L6.92084 11.6521C6.54721 11.2706 6.54722 10.652 6.92087 10.2705C7.29451 9.88902 7.90029 9.88903 8.27392 10.2706L10.7316 12.7801L15.362 8.37813C15.7488 8.01048 16.3542 8.03256 16.7142 8.42745Z" fill="white"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.returned}</div>
			</li>
`;

const returnProcessSix = `
<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			
			<li class="tpt-order-process__dot tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8055" cy="11.8055" r="8.85437" fill="#D01345"/>
					<circle cx="11.8057" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"/>
					<path d="M14.8057 7.49902C14.9767 7.49902 15.1407 7.56669 15.2617 7.6875C15.3828 7.80857 15.4512 7.97331 15.4512 8.14453C15.4511 8.31572 15.3827 8.47954 15.2617 8.60059L12.3984 11.459L12.3818 11.4746L12.3984 11.4912L15.2617 14.3486V14.3496C15.322 14.4094 15.3707 14.4803 15.4033 14.5586C15.4359 14.6368 15.4521 14.7209 15.4521 14.8057C15.4521 14.8904 15.4359 14.9745 15.4033 15.0527C15.3707 15.1311 15.322 15.202 15.2617 15.2617C15.202 15.322 15.1311 15.3707 15.0527 15.4033C14.9745 15.4359 14.8904 15.4521 14.8057 15.4521C14.7209 15.4521 14.6368 15.4359 14.5586 15.4033C14.4803 15.3707 14.4094 15.322 14.3496 15.2617L11.4922 12.3975L11.4756 12.3809L11.459 12.3975L8.60156 15.2617C8.54181 15.322 8.47091 15.3707 8.39258 15.4033C8.31433 15.4359 8.23027 15.4521 8.14551 15.4521C8.06076 15.4521 7.97668 15.4359 7.89844 15.4033C7.82011 15.3707 7.74921 15.322 7.68945 15.2617C7.62921 15.202 7.58048 15.1311 7.54785 15.0527C7.51529 14.9745 7.49903 14.8904 7.49902 14.8057C7.49902 14.7209 7.51531 14.6368 7.54785 14.5586C7.58048 14.4803 7.62921 14.4094 7.68945 14.3496V14.3486L10.5527 11.4912L10.5693 11.4746L10.5527 11.459L7.68945 8.60059C7.56842 8.47954 7.50003 8.31572 7.5 8.14453C7.5 7.97331 7.5684 7.80857 7.68945 7.6875C7.81047 7.56669 7.97451 7.49902 8.14551 7.49902C8.31651 7.49903 8.48055 7.56668 8.60156 7.6875L11.459 10.5518L11.4756 10.5684L11.4922 10.5518L14.3496 7.6875C14.4706 7.56668 14.6347 7.49903 14.8057 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text" style="color: #D01345;">${window.tptTrackOrder.failed_delivery}</div>
			</li>


			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g opacity="0.4">
					<circle cx="5.53479" cy="5.53576" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"/>
					<circle cx="5.5344" cy="5.5344" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"/>
					</g>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.returned}</div>
			</li>
`;

const returnProcessTwo = `
<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8055" cy="11.8055" r="8.85437" fill="#D01345"/>
					<circle cx="11.8057" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"/>
					<path d="M14.8057 7.49902C14.9767 7.49902 15.1407 7.56669 15.2617 7.6875C15.3828 7.80857 15.4512 7.97331 15.4512 8.14453C15.4511 8.31572 15.3827 8.47954 15.2617 8.60059L12.3984 11.459L12.3818 11.4746L12.3984 11.4912L15.2617 14.3486V14.3496C15.322 14.4094 15.3707 14.4803 15.4033 14.5586C15.4359 14.6368 15.4521 14.7209 15.4521 14.8057C15.4521 14.8904 15.4359 14.9745 15.4033 15.0527C15.3707 15.1311 15.322 15.202 15.2617 15.2617C15.202 15.322 15.1311 15.3707 15.0527 15.4033C14.9745 15.4359 14.8904 15.4521 14.8057 15.4521C14.7209 15.4521 14.6368 15.4359 14.5586 15.4033C14.4803 15.3707 14.4094 15.322 14.3496 15.2617L11.4922 12.3975L11.4756 12.3809L11.459 12.3975L8.60156 15.2617C8.54181 15.322 8.47091 15.3707 8.39258 15.4033C8.31433 15.4359 8.23027 15.4521 8.14551 15.4521C8.06076 15.4521 7.97668 15.4359 7.89844 15.4033C7.82011 15.3707 7.74921 15.322 7.68945 15.2617C7.62921 15.202 7.58048 15.1311 7.54785 15.0527C7.51529 14.9745 7.49903 14.8904 7.49902 14.8057C7.49902 14.7209 7.51531 14.6368 7.54785 14.5586C7.58048 14.4803 7.62921 14.4094 7.68945 14.3496V14.3486L10.5527 11.4912L10.5693 11.4746L10.5527 11.459L7.68945 8.60059C7.56842 8.47954 7.50003 8.31572 7.5 8.14453C7.5 7.97331 7.5684 7.80857 7.68945 7.6875C7.81047 7.56669 7.97451 7.49902 8.14551 7.49902C8.31651 7.49903 8.48055 7.56668 8.60156 7.6875L11.459 10.5518L11.4756 10.5684L11.4922 10.5518L14.3496 7.6875C14.4706 7.56668 14.6347 7.49903 14.8057 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text" style="color: #D01345;">${window.tptTrackOrder.failed_delivery}</div>
			</li>


			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8055" cy="11.8055" r="8.85437" fill="#12283E"/>
					<circle cx="11.8057" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7142 8.42745C17.0743 8.82234 17.0526 9.4405 16.6659 9.80815L10.6841 15.4949L6.92084 11.6521C6.54721 11.2706 6.54722 10.652 6.92087 10.2705C7.29451 9.88902 7.90029 9.88903 8.27392 10.2706L10.7316 12.7801L15.362 8.37813C15.7488 8.01048 16.3542 8.03256 16.7142 8.42745Z" fill="white"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.returned}</div>
			</li>

			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8055" cy="11.8055" r="8.85437" fill="#12283E"/>
					<circle cx="11.8057" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7142 8.42745C17.0743 8.82234 17.0526 9.4405 16.6659 9.80815L10.6841 15.4949L6.92084 11.6521C6.54721 11.2706 6.54722 10.652 6.92087 10.2705C7.29451 9.88902 7.90029 9.88903 8.27392 10.2706L10.7316 12.7801L15.362 8.37813C15.7488 8.01048 16.3542 8.03256 16.7142 8.42745Z" fill="white"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.refunded}</div>
			</li>
`;

const returnProcessThree = `
<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8055" cy="11.8055" r="8.85437" fill="#D01345"/>
					<circle cx="11.8057" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"/>
					<path d="M14.8057 7.49902C14.9767 7.49902 15.1407 7.56669 15.2617 7.6875C15.3828 7.80857 15.4512 7.97331 15.4512 8.14453C15.4511 8.31572 15.3827 8.47954 15.2617 8.60059L12.3984 11.459L12.3818 11.4746L12.3984 11.4912L15.2617 14.3486V14.3496C15.322 14.4094 15.3707 14.4803 15.4033 14.5586C15.4359 14.6368 15.4521 14.7209 15.4521 14.8057C15.4521 14.8904 15.4359 14.9745 15.4033 15.0527C15.3707 15.1311 15.322 15.202 15.2617 15.2617C15.202 15.322 15.1311 15.3707 15.0527 15.4033C14.9745 15.4359 14.8904 15.4521 14.8057 15.4521C14.7209 15.4521 14.6368 15.4359 14.5586 15.4033C14.4803 15.3707 14.4094 15.322 14.3496 15.2617L11.4922 12.3975L11.4756 12.3809L11.459 12.3975L8.60156 15.2617C8.54181 15.322 8.47091 15.3707 8.39258 15.4033C8.31433 15.4359 8.23027 15.4521 8.14551 15.4521C8.06076 15.4521 7.97668 15.4359 7.89844 15.4033C7.82011 15.3707 7.74921 15.322 7.68945 15.2617C7.62921 15.202 7.58048 15.1311 7.54785 15.0527C7.51529 14.9745 7.49903 14.8904 7.49902 14.8057C7.49902 14.7209 7.51531 14.6368 7.54785 14.5586C7.58048 14.4803 7.62921 14.4094 7.68945 14.3496V14.3486L10.5527 11.4912L10.5693 11.4746L10.5527 11.459L7.68945 8.60059C7.56842 8.47954 7.50003 8.31572 7.5 8.14453C7.5 7.97331 7.5684 7.80857 7.68945 7.6875C7.81047 7.56669 7.97451 7.49902 8.14551 7.49902C8.31651 7.49903 8.48055 7.56668 8.60156 7.6875L11.459 10.5518L11.4756 10.5684L11.4922 10.5518L14.3496 7.6875C14.4706 7.56668 14.6347 7.49903 14.8057 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text" style="color: #D01345;">${window.tptTrackOrder.failed_delivery}</div>
			</li>


			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8055" cy="11.8055" r="8.85437" fill="#12283E"/>
					<circle cx="11.8057" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7142 8.42745C17.0743 8.82234 17.0526 9.4405 16.6659 9.80815L10.6841 15.4949L6.92084 11.6521C6.54721 11.2706 6.54722 10.652 6.92087 10.2705C7.29451 9.88902 7.90029 9.88903 8.27392 10.2706L10.7316 12.7801L15.362 8.37813C15.7488 8.01048 16.3542 8.03256 16.7142 8.42745Z" fill="white"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.returned}</div>
			</li>

			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g opacity="0.4">
					<circle cx="5.53479" cy="5.53576" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"/>
					<circle cx="5.5344" cy="5.5344" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"/>
					</g>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.refunded}</div>
			</li>
`;

const returnProcessFour = `
<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			<li class="tpt-order-process__dot tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8055" cy="11.8055" r="8.85437" fill="#12283E"/>
					<circle cx="11.8057" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7142 8.42745C17.0743 8.82234 17.0526 9.4405 16.6659 9.80815L10.6841 15.4949L6.92084 11.6521C6.54721 11.2706 6.54722 10.652 6.92087 10.2705C7.29451 9.88902 7.90029 9.88903 8.27392 10.2706L10.7316 12.7801L15.362 8.37813C15.7488 8.01048 16.3542 8.03256 16.7142 8.42745Z" fill="white"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.returned}</div>
			</li>

			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g opacity="0.4">
					<circle cx="5.53479" cy="5.53576" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"/>
					<circle cx="5.5344" cy="5.5344" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"/>
					</g>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.refunded}</div>
			</li>
`;

const returnProcessFive = `
<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			<li class="tpt-order-process__dot ">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8055" cy="11.8055" r="8.85437" fill="#12283E"/>
					<circle cx="11.8057" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7142 8.42745C17.0743 8.82234 17.0526 9.4405 16.6659 9.80815L10.6841 15.4949L6.92084 11.6521C6.54721 11.2706 6.54722 10.652 6.92087 10.2705C7.29451 9.88902 7.90029 9.88903 8.27392 10.2706L10.7316 12.7801L15.362 8.37813C15.7488 8.01048 16.3542 8.03256 16.7142 8.42745Z" fill="white"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.returned}</div>
			</li>

			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8055" cy="11.8055" r="8.85437" fill="#12283E"/>
					<circle cx="11.8057" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7142 8.42745C17.0743 8.82234 17.0526 9.4405 16.6659 9.80815L10.6841 15.4949L6.92084 11.6521C6.54721 11.2706 6.54722 10.652 6.92087 10.2705C7.29451 9.88902 7.90029 9.88903 8.27392 10.2706L10.7316 12.7801L15.362 8.37813C15.7488 8.01048 16.3542 8.03256 16.7142 8.42745Z" fill="white"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.refunded}</div>
			</li>
`;

const PRODUCT_HTML = `<div class="tpt-order-tracker__product-item">
						<div class="tpt-order-tracker__product-image">__PRODUCT_IMAGE__</div>

						<div class="tpt-order-tracker__product-info">
							<div class="tpt-order-tracker__product-info-title">__PRODUCT__TITLE__</div>
							<div class="tpt-order-tracker__product-info-variant">__PRODUCT__VARIANT__</div>
						</div>

						<div class="tpt-order-tracker__product-price">__PRODUCT_PRICE__</div>
					</div>
					`;

const PRODUCT_HTML_CONFIRMED = `<div class="tpt-order-tracker__item-detail">
								<div class="tpt-order__packed-info">
									<div class="tpt-order__packed-info-number">${window.tptTrackOrder.tracking} -</div>
									<div class="tpt-order__packed-info-date">${window.tptTrackOrder.confirmedOn} __CONFIRMED_DATE__</div>
								</div>

								<div id="tpt-order-tracker__products-shipping" class="tpt-order-tracker__products">
									<div class="tpt-order-tracker__product-item">
										<div class="tpt-order-tracker__product-image">__PRODUCT_IMAGE__</div>

										<div class="tpt-order-tracker__product-info">
											<div class="tpt-order-tracker__product-info-title">__PRODUCT__TITLE__</div>
											<div class="tpt-order-tracker__product-info-variant">__PRODUCT__VARIANT__</div>
										</div>

										<div class="tpt-order-tracker__product-price">__PRODUCT_PRICE__</div>
									</div>
								</div>

								<div class="tpt-order-process">
								<ul class="tpt-order-process__list">
									<li class="tpt-order-process__dot tpt-order-process__dot--finish">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g opacity="0.4">
											<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											</g>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.packed}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g opacity="0.4">
											<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											</g>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.shipping}</div>
									</li>

									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g opacity="0.4">
											<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											</g>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.delivered}</div>
									</li>
								</ul>
								</div>
							</div>`;

const PRODUCT_HTML_PICKUP_CONFIRMED = `<div class="tpt-order-tracker__item-detail">
								<div class="tpt-order__packed-info">
									<div class="tpt-order__packed-info-number">${window.tptTrackOrder.tracking} -</div>
									<div class="tpt-order__packed-info-date">${window.tptTrackOrder.confirmedOn} __CONFIRMED_DATE__</div>
								</div>

								<div id="tpt-order-tracker__products-shipping" class="tpt-order-tracker__products">
									<div class="tpt-order-tracker__product-item">
										<div class="tpt-order-tracker__product-image">__PRODUCT_IMAGE__</div>

										<div class="tpt-order-tracker__product-info">
											<div class="tpt-order-tracker__product-info-title">__PRODUCT__TITLE__</div>
											<div class="tpt-order-tracker__product-info-variant">__PRODUCT__VARIANT__</div>
										</div>

										<div class="tpt-order-tracker__product-price">__PRODUCT_PRICE__</div>
									</div>
								</div>

								<div class="tpt-order-process">
								<ul class="tpt-order-process__list">
									<li class="tpt-order-process__dot tpt-order-process__dot--finish">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g opacity="0.4">
											<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											</g>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.readyToCollect}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g opacity="0.4">
											<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											</g>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.collected}</div>
									</li>
								</ul>
								</div>
							</div>`;

const PRODUCT_HTML_PACKED = `<div class="tpt-order-tracker__item-detail">
								<div class="tpt-order__packed-info">
									<div class="tpt-order__packed-info-number">${window.tptTrackOrder.tracking} __PACKED_TRACKING_NUMBER__ ${SHIPPING_NOTE}</div>
									<div class="tpt-order__packed-info-date">${window.tptTrackOrder.packedOn} __PACKED_DATE__</div>
								</div>

								<div id="tpt-order-tracker__products-packed" class="tpt-order-tracker__products">
									<div class="tpt-order-tracker__product-item">
										<div class="tpt-order-tracker__product-image">__PRODUCT_IMAGE__</div>

										<div class="tpt-order-tracker__product-info">
											<div class="tpt-order-tracker__product-info-title">__PRODUCT__TITLE__</div>
											<div class="tpt-order-tracker__product-info-variant">__PRODUCT__VARIANT__</div>
										</div>

										<div class="tpt-order-tracker__product-price">__PRODUCT_PRICE__</div>
									</div>
								</div>

								<div class="tpt-order-process">
								<ul class="tpt-order-process__list">
									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot tpt-order-process__dot--finish">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.packed}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g opacity="0.4">
											<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											</g>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.shipping}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g opacity="0.4">
											<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											</g>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.delivered}</div>
									</li>
								</ul>
								</div>
							</div>`;

const PRODUCT_HTML_PACKED_GROUP = `
	<div class="tpt-order-tracker__item-detail">
		<div class="tpt-order__packed-info">
			<div class="tpt-order__packed-info-number">
				${window.tptTrackOrder.tracking} __PACKED_TRACKING_NUMBER__ ${SHIPPING_NOTE}
			</div>
			<div class="tpt-order__packed-info-date">
				${window.tptTrackOrder.packedOn} __PACKED_DATE__
			</div>
		</div>

		<div class="tpt-order-tracker__products">
			__PRODUCTS__
		</div>

		<div class="tpt-order-process">
			<ul class="tpt-order-process__list">
				<li class="tpt-order-process__dot">
					<div class="tpt-order-process__dot-icon">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
						<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
						</svg>
					</div>
					<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
				</li>


				<li class="tpt-order-process__dash"></li>

				<li class="tpt-order-process__dot tpt-order-process__dot--finish">
					<div class="tpt-order-process__dot-icon">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
						<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
						</svg>
					</div>
					<div class="tpt-order-process__dot-text">${window.tptTrackOrder.packed}</div>
				</li>


				<li class="tpt-order-process__dash"></li>

				<li class="tpt-order-process__dot">
					<div class="tpt-order-process__dot-icon">
						<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g opacity="0.4">
						<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
						<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
						</g>
						</svg>
					</div>
					<div class="tpt-order-process__dot-text">${window.tptTrackOrder.shipping}</div>
				</li>


				<li class="tpt-order-process__dash"></li>

				<li class="tpt-order-process__dot">
					<div class="tpt-order-process__dot-icon">
						<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g opacity="0.4">
						<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
						<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
						</g>
						</svg>
					</div>
					<div class="tpt-order-process__dot-text">${window.tptTrackOrder.delivered}</div>
				</li>
			</ul>
			</div>
		</div>
	`;

const PRODUCT_ITEM_HTML_PACKED = `
	<div class="tpt-order-tracker__product-item">
		<div class="tpt-order-tracker__product-image">__PRODUCT_IMAGE__</div>

		<div class="tpt-order-tracker__product-info">
			<div class="tpt-order-tracker__product-info-title">__PRODUCT__TITLE__</div>
			<div class="tpt-order-tracker__product-info-variant">__PRODUCT__VARIANT__</div>
		</div>

		<div class="tpt-order-tracker__product-price">__PRODUCT_PRICE__</div>
	</div>
	`;

const PRODUCT_ITEM_HTML_DELIVERED = `
	<div class="tpt-order-tracker__product-item">
		<div class="tpt-order-tracker__product-image">__PRODUCT_IMAGE__</div>

		<div class="tpt-order-tracker__product-info">
			<div class="tpt-order-tracker__product-info-title">__PRODUCT__TITLE__</div>
			<div class="tpt-order-tracker__product-info-variant">__PRODUCT__VARIANT__</div>
		</div>

		<div class="tpt-order-tracker__product-price">__PRODUCT_PRICE__</div>
	</div>
	`;

const PRODUCT_HTML_DELIVERED_GROUP = `
	<div class="tpt-order-tracker__item-detail">
		<div class="tpt-order__packed-info">
			<div class="tpt-order__packed-info-number">
				${window.tptTrackOrder.tracking} __PACKED_TRACKING_NUMBER__ ${SHIPPING_NOTE}
			</div>
			<div class="tpt-order__packed-info-date">
				${window.tptTrackOrder.packedOn} __PACKED_DATE__
			</div>
		</div>

		<div class="tpt-order-tracker__products">
			__PRODUCTS__
		</div>

		<div class="tpt-order-process">
			<ul class="tpt-order-process__list">
				<li class="tpt-order-process__dot">
					<div class="tpt-order-process__dot-icon">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
						<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
						</svg>
					</div>
					<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
				</li>


				<li class="tpt-order-process__dash"></li>

				<li class="tpt-order-process__dot">
					<div class="tpt-order-process__dot-icon">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
						<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
						</svg>
					</div>
					<div class="tpt-order-process__dot-text">${window.tptTrackOrder.packed}</div>
				</li>


				<li class="tpt-order-process__dash"></li>

				<li class="tpt-order-process__dot">
					<div class="tpt-order-process__dot-icon">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
						<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
						</svg>
					</div>
					<div class="tpt-order-process__dot-text">${window.tptTrackOrder.shipping}</div>
				</li>


				<li class="tpt-order-process__dash"></li>

				<li class="tpt-order-process__dot tpt-order-process__dot--finish">
					<div class="tpt-order-process__dot-icon">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
						<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
						</svg>
					</div>
					<div class="tpt-order-process__dot-text">${window.tptTrackOrder.delivered}</div>
				</li>
			</ul>
			</div>
		</div>
	`;

const PRODUCT_HTML_CANCELED = `<div class="tpt-order-tracker__item-detail">
								<div class="tpt-order__packed-info">
									<div class="tpt-order__packed-info-number"><span class="home-delivery-tracking">${window.tptTrackOrder.tracking}</span><span class="pickup-in-store-label">${window.tptTrackOrder.pickup}</span>-</div>
									<div class="tpt-order__packed-info-date">${window.tptTrackOrder.canceledOn} __CANCELED_DATE__</div>
								</div>

								<div id="tpt-order-tracker__products-packed" class="tpt-order-tracker__products">
									<div class="tpt-order-tracker__product-item">
										<div class="tpt-order-tracker__product-image">__PRODUCT_IMAGE__</div>

										<div class="tpt-order-tracker__product-info">
											<div class="tpt-order-tracker__product-info-title">__PRODUCT__TITLE__</div>
											<div class="tpt-order-tracker__product-info-variant">__PRODUCT__VARIANT__</div>
										</div>

										<div class="tpt-order-tracker__product-price">__PRODUCT_PRICE__</div>
									</div>
								</div>

								<div class="tpt-order-process">
									<ul class="tpt-order-process__list">
										<li class="tpt-order-process__dot">
											<div class="tpt-order-process__dot-icon">
												<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
												<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
												<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
												</svg>
											</div>
											<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
										</li>


										<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

										
										<li class="tpt-order-process__dot tpt-order-process__dot--canceled tpt-order-process__dot--finish">
											<div class="tpt-order-process__dot-icon">
												<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#D01345"/>
												<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"/>
												<path d="M14.8058 7.49902C14.9768 7.49902 15.1408 7.56669 15.2618 7.6875C15.3829 7.80857 15.4513 7.97331 15.4513 8.14453C15.4513 8.31572 15.3829 8.47954 15.2618 8.60059L12.3986 11.459L12.382 11.4746L12.3986 11.4912L15.2618 14.3486V14.3496C15.3221 14.4094 15.3708 14.4803 15.4034 14.5586C15.436 14.6368 15.4523 14.7209 15.4523 14.8057C15.4523 14.8904 15.436 14.9745 15.4034 15.0527C15.3708 15.1311 15.3221 15.202 15.2618 15.2617C15.2021 15.322 15.1312 15.3707 15.0529 15.4033C14.9746 15.4359 14.8905 15.4521 14.8058 15.4521C14.721 15.4521 14.637 15.4359 14.5587 15.4033C14.4804 15.3707 14.4095 15.322 14.3497 15.2617L11.4923 12.3975L11.4757 12.3809L11.4591 12.3975L8.60168 15.2617C8.54193 15.322 8.47103 15.3707 8.3927 15.4033C8.31445 15.4359 8.23039 15.4521 8.14563 15.4521C8.06088 15.4521 7.97681 15.4359 7.89856 15.4033C7.82023 15.3707 7.74933 15.322 7.68958 15.2617C7.62933 15.202 7.58061 15.1311 7.54797 15.0527C7.51541 14.9745 7.49915 14.8904 7.49915 14.8057C7.49915 14.7209 7.51543 14.6368 7.54797 14.5586C7.58061 14.4803 7.62933 14.4094 7.68958 14.3496V14.3486L10.5529 11.4912L10.5695 11.4746L10.5529 11.459L7.68958 8.60059C7.56854 8.47954 7.50015 8.31572 7.50012 8.14453C7.50012 7.97331 7.56852 7.80857 7.68958 7.6875C7.81059 7.56669 7.97463 7.49902 8.14563 7.49902C8.31663 7.49903 8.48068 7.56668 8.60168 7.6875L11.4591 10.5518L11.4757 10.5684L11.4923 10.5518L14.3497 7.6875C14.4707 7.56668 14.6348 7.49903 14.8058 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"/>
												</svg>
											</div>
											<div class="tpt-order-process__dot-text">${window.tptTrackOrder.canceled}</div>
										</li>


										<li class="tpt-order-process__dash"></li>

				
										<li class="tpt-order-process__dot">
											<div class="tpt-order-process__dot-icon">
												<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
												<g opacity="0.4">
												<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"/>
												<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"/>
												</g>
												</svg>
											</div>
											<div class="tpt-order-process__dot-text">${window.tptTrackOrder.refunded}</div>
										</li>
									</ul>
								</div>
							</div>`;

const PRODUCT_HTML_SHIPPING = `<div class="tpt-order-tracker__item-detail">
								<div class="tpt-order__packed-info">
									<div class="tpt-order__packed-info-number">${window.tptTrackOrder.tracking} __SHIPPING_TRACKING_NUMBER__ ${SHIPPING_NOTE}</div>
									<div class="tpt-order__packed-info-date">${window.tptTrackOrder.shippingOn} __SHIPPING_DATE__</div>
								</div>

								<div id="tpt-order-tracker__products-shipping" class="tpt-order-tracker__products">
									<div class="tpt-order-tracker__product-item">
										<div class="tpt-order-tracker__product-image">__PRODUCT_IMAGE__</div>

										<div class="tpt-order-tracker__product-info">
											<div class="tpt-order-tracker__product-info-title">__PRODUCT__TITLE__</div>
											<div class="tpt-order-tracker__product-info-variant">__PRODUCT__VARIANT__</div>
										</div>

										<div class="tpt-order-tracker__product-price">__PRODUCT_PRICE__</div>
									</div>
								</div>

								<div class="tpt-order-process">
								<ul class="tpt-order-process__list">
									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.packed}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot tpt-order-process__dot--finish">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.shipping}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g opacity="0.4">
											<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											</g>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.delivered}</div>
									</li>
								</ul>
								</div>
							</div>`;

const PRODUCT_HTML_SHIPPING_GROUP = `
<div class="tpt-order-tracker__item-detail">
	<div class="tpt-order__packed-info">
		<div class="tpt-order__packed-info-number">
			${window.tptTrackOrder.tracking} __SHIPPING_TRACKING_NUMBER__ ${SHIPPING_NOTE}
		</div>

		<div class="tpt-order__packed-info-date">
			${window.tptTrackOrder.shippingOn} __SHIPPING_DATE__
		</div>
	</div>

	<div class="tpt-order-tracker__products">
		__PRODUCTS__
	</div>

	<div class="tpt-order-process">
		<ul class="tpt-order-process__list">
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash"></li>

			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.packed}</div>
			</li>


			<li class="tpt-order-process__dash"></li>

			<li class="tpt-order-process__dot tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.shipping}</div>
			</li>


			<li class="tpt-order-process__dash"></li>

			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g opacity="0.4">
					<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
					<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
					</g>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.delivered}</div>
			</li>
		</ul>
	</div>
</div>
`;

const PRODUCT_ITEM_HTML_SHIPPING = `
<div class="tpt-order-tracker__product-item">
	<div class="tpt-order-tracker__product-image">
		__PRODUCT_IMAGE__
	</div>

	<div class="tpt-order-tracker__product-info">
		<div class="tpt-order-tracker__product-info-title">
			__PRODUCT__TITLE__
		</div>

		<div class="tpt-order-tracker__product-info-variant">
			__PRODUCT__VARIANT__
		</div>
	</div>

	<div class="tpt-order-tracker__product-price">
		__PRODUCT_PRICE__
	</div>
</div>
`;

const PRODUCT_HTML_DELIVERED = `<div class="tpt-order-tracker__item-detail">
								<div class="tpt-order__packed-info">
									<div class="tpt-order__packed-info-number">${window.tptTrackOrder.tracking} __PACKED_TRACKING_NUMBER__ ${SHIPPING_NOTE}</div>
									<div class="tpt-order__packed-info-date">${window.tptTrackOrder.deliveredOn} __DELIVERED_DATE__</div>
								</div>

								<div id="tpt-order-tracker__products-packed" class="tpt-order-tracker__products">
									<div class="tpt-order-tracker__product-item">
										<div class="tpt-order-tracker__product-image">__PRODUCT_IMAGE__</div>

										<div class="tpt-order-tracker__product-info">
											<div class="tpt-order-tracker__product-info-title">__PRODUCT__TITLE__</div>
											<div class="tpt-order-tracker__product-info-variant">__PRODUCT__VARIANT__</div>
										</div>

										<div class="tpt-order-tracker__product-price">__PRODUCT_PRICE__</div>
									</div>
								</div>

								<div class="tpt-order-process">
								<ul class="tpt-order-process__list">
									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.packed}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.shipping}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot tpt-order-process__dot--finish">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.delivered}</div>
									</li>
								</ul>
								</div>
							</div>`;

const PRODUCT_HTML_REFUNDED = `<div class="tpt-order-tracker__item-detail">
								<div class="tpt-order__packed-info">
									<div class="tpt-order__packed-info-number">${window.tptTrackOrder.tracking} -</div>
									<div class="tpt-order__packed-info-date">${window.tptTrackOrder.refundedOn} __REFUNDED_DATE__</div>
								</div>

								<div id="tpt-order-tracker__products-packed" class="tpt-order-tracker__products">
									<div class="tpt-order-tracker__product-item">
										<div class="tpt-order-tracker__product-image">__PRODUCT_IMAGE__</div>

										<div class="tpt-order-tracker__product-info">
											<div class="tpt-order-tracker__product-info-title">__PRODUCT__TITLE__</div>
											<div class="tpt-order-tracker__product-info-variant">__PRODUCT__VARIANT__</div>
										</div>

										<div class="tpt-order-tracker__product-price">__PRODUCT_PRICE__</div>
									</div>
								</div>

								<div class="tpt-order-process">
									<ul class="tpt-order-process__list">
													<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
										</li>


													<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

													<li class="tpt-order-process__dot tpt-order-process__dot--canceled ">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#D01345"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"></circle>
											<path d="M14.8058 7.49902C14.9768 7.49902 15.1408 7.56669 15.2618 7.6875C15.3829 7.80857 15.4513 7.97331 15.4513 8.14453C15.4513 8.31572 15.3829 8.47954 15.2618 8.60059L12.3986 11.459L12.382 11.4746L12.3986 11.4912L15.2618 14.3486V14.3496C15.3221 14.4094 15.3708 14.4803 15.4034 14.5586C15.436 14.6368 15.4523 14.7209 15.4523 14.8057C15.4523 14.8904 15.436 14.9745 15.4034 15.0527C15.3708 15.1311 15.3221 15.202 15.2618 15.2617C15.2021 15.322 15.1312 15.3707 15.0529 15.4033C14.9746 15.4359 14.8905 15.4521 14.8058 15.4521C14.721 15.4521 14.637 15.4359 14.5587 15.4033C14.4804 15.3707 14.4095 15.322 14.3497 15.2617L11.4923 12.3975L11.4757 12.3809L11.4591 12.3975L8.60168 15.2617C8.54193 15.322 8.47103 15.3707 8.3927 15.4033C8.31445 15.4359 8.23039 15.4521 8.14563 15.4521C8.06088 15.4521 7.97681 15.4359 7.89856 15.4033C7.82023 15.3707 7.74933 15.322 7.68958 15.2617C7.62933 15.202 7.58061 15.1311 7.54797 15.0527C7.51541 14.9745 7.49915 14.8904 7.49915 14.8057C7.49915 14.7209 7.51543 14.6368 7.54797 14.5586C7.58061 14.4803 7.62933 14.4094 7.68958 14.3496V14.3486L10.5529 11.4912L10.5695 11.4746L10.5529 11.459L7.68958 8.60059C7.56854 8.47954 7.50015 8.31572 7.50012 8.14453C7.50012 7.97331 7.56852 7.80857 7.68958 7.6875C7.81059 7.56669 7.97463 7.49902 8.14563 7.49902C8.31663 7.49903 8.48068 7.56668 8.60168 7.6875L11.4591 10.5518L11.4757 10.5684L11.4923 10.5518L14.3497 7.6875C14.4707 7.56668 14.6348 7.49903 14.8058 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.canceled}</div>
										</li>


													<li class="tpt-order-process__dash"></li>

													<li class="tpt-order-process__dot tpt-order-process__dot--finish">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.refunded}</div>
										</li>

												</ul>
								</div>
							</div>`;

const PRODUCT_HTML_RETURNED = `<div class="tpt-order-tracker__item-detail">
								<div class="tpt-order__packed-info">
									<div class="tpt-order__packed-info-number">${window.tptTrackOrder.tracking} -</div>
									<div class="tpt-order__packed-info-date">${window.tptTrackOrder.returnedOn} __RETURNED_DATE__</div>
								</div>

								<div id="tpt-order-tracker__products-packed" class="tpt-order-tracker__products">
									<div class="tpt-order-tracker__product-item">
										<div class="tpt-order-tracker__product-image">__PRODUCT_IMAGE__</div>

										<div class="tpt-order-tracker__product-info">
											<div class="tpt-order-tracker__product-info-title">__PRODUCT__TITLE__</div>
											<div class="tpt-order-tracker__product-info-variant">__PRODUCT__VARIANT__</div>
										</div>

										<div class="tpt-order-tracker__product-price">__PRODUCT_PRICE__</div>
									</div>
								</div>

								<div class="tpt-order-process">
									<ul class="tpt-order-process__list">
													<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
										</li>


													<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

													<li class="tpt-order-process__dot tpt-order-process__dot--finish">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.returned}</div>
										</li>


													<li class="tpt-order-process__dash"></li>

													<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g opacity="0.4">
											<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											</g>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.refunded}</div>
										</li>

												</ul>
								</div>
							</div>`;

const PRODUCT_HTML_READY_TO_COLLECTED_GROUP = `<div class="tpt-order-tracker__item-detail">
								<div class="tpt-order__packed-info">
									<div class="tpt-order__packed-info-number">${window.tptTrackOrder.pickup} __COLLECTED_TRACKING_NUMBER__</div>
									<div class="tpt-order__packed-info-date">${window.tptTrackOrder.collectedOn} __COLLECTED_DATE__</div>
								</div>

								<div id="tpt-order-tracker__products-readytocollect" class="tpt-order-tracker__products">
									__PRODUCTS__
								</div>

								<div class="tpt-order-process">
								<ul class="tpt-order-process__list">
									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot tpt-order-process__dot--finish">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.readyToCollect}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g opacity="0.4">
											<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
											</g>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.collected}</div>
									</li>
								</ul>
								</div>
							</div>`;

const PRODUCT_HTML_COLLECTED = `<div class="tpt-order-tracker__item-detail">
								<div class="tpt-order__packed-info">
									<div class="tpt-order__packed-info-number">${window.tptTrackOrder.pickup} __COLLECTED_TRACKING_NUMBER__</div>
									<div class="tpt-order__packed-info-date">${window.tptTrackOrder.collectedOn} __COLLECTED_DATE__</div>
								</div>

								<div id="tpt-order-tracker__products-shipping" class="tpt-order-tracker__products">
									<div class="tpt-order-tracker__product-item">
										<div class="tpt-order-tracker__product-image">__PRODUCT_IMAGE__</div>

										<div class="tpt-order-tracker__product-info">
											<div class="tpt-order-tracker__product-info-title">__PRODUCT__TITLE__</div>
											<div class="tpt-order-tracker__product-info-variant">__PRODUCT__VARIANT__</div>
										</div>

										<div class="tpt-order-tracker__product-price">__PRODUCT_PRICE__</div>
									</div>
								</div>

								<div class="tpt-order-process">
								<ul class="tpt-order-process__list">
									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.readyToCollect}</div>
									</li>


									<li class="tpt-order-process__dash"></li>

									<li class="tpt-order-process__dot tpt-order-process__dot--finish">
										<div class="tpt-order-process__dot-icon">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
											<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
											</svg>
										</div>
										<div class="tpt-order-process__dot-text">${window.tptTrackOrder.collected}</div>
									</li>
								</ul>
								</div>
							</div>`;

const PRODUCT_HTML_RETURN_NOTE_NO_REFUND_LABEL_GROUP = `
<div class="tpt-order-tracker__item-detail">
	<div class="tpt-order-tracker__products">
		__PRODUCTS__
	</div>

	<div class="tpt-order-process">
		<ul class="tpt-order-process__list">
			__PROCESS_DOTS__
		</ul>
	</div>
</div>
`;

const PRODUCT_HTML_RETURN_NOTE_REFUND_LABEL_GROUP = `
<div class="tpt-order-tracker__item-detail">
	${REFUND_LABEL}

	<div class="tpt-order-tracker__products">
		__PRODUCTS__
	</div>

	<div class="tpt-order-process">
		<ul class="tpt-order-process__list">
			__PROCESS_DOTS__
		</ul>
	</div>
</div>
`;

const PRODUCT_ITEM_HTML_RETURN = `
<div class="tpt-order-tracker__product-item">
	<div class="tpt-order-tracker__product-image">
		__PRODUCT_IMAGE__
	</div>

	<div class="tpt-order-tracker__product-info">
		<div class="tpt-order-tracker__product-info-title">
			__PRODUCT_TITLE__
		</div>

		<div class="tpt-order-tracker__product-info-variant">
			__PRODUCT_VARIANT__
		</div>
	</div>

	<div class="tpt-order-tracker__product-price">
		__PRODUCT_PRICE__
	</div>
</div>
`;

const PRODUCT_ITEM_HTML_READY_TO_COLLECT = `
<div class="tpt-order-tracker__product-item">
	<div class="tpt-order-tracker__product-image">
		__PRODUCT_IMAGE__
	</div>

	<div class="tpt-order-tracker__product-info">
		<div class="tpt-order-tracker__product-info-title">
			__PRODUCT_TITLE__
		</div>

		<div class="tpt-order-tracker__product-info-variant">
			__PRODUCT_VARIANT__
		</div>
	</div>

	<div class="tpt-order-tracker__product-price">
		__PRODUCT_PRICE__
	</div>
</div>
`;

const PRODUCT_HTML_VOIDED_CANCELED_GROUP = `
<div class="tpt-order-tracker__item-detail">
	${REFUND_LABEL}

	<div class="tpt-order-tracker__products">
		__PRODUCTS__
	</div>

	<div class="tpt-order-process">
		<ul class="tpt-order-process__list tpt-order-process__list-default">
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			
			<li class="tpt-order-process__dot tpt-order-process__dot--canceled tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#D01345"/>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"/>
					<path d="M14.8058 7.49902C14.9768 7.49902 15.1408 7.56669 15.2618 7.6875C15.3829 7.80857 15.4513 7.97331 15.4513 8.14453C15.4513 8.31572 15.3829 8.47954 15.2618 8.60059L12.3986 11.459L12.382 11.4746L12.3986 11.4912L15.2618 14.3486V14.3496C15.3221 14.4094 15.3708 14.4803 15.4034 14.5586C15.436 14.6368 15.4523 14.7209 15.4523 14.8057C15.4523 14.8904 15.436 14.9745 15.4034 15.0527C15.3708 15.1311 15.3221 15.202 15.2618 15.2617C15.2021 15.322 15.1312 15.3707 15.0529 15.4033C14.9746 15.4359 14.8905 15.4521 14.8058 15.4521C14.721 15.4521 14.637 15.4359 14.5587 15.4033C14.4804 15.3707 14.4095 15.322 14.3497 15.2617L11.4923 12.3975L11.4757 12.3809L11.4591 12.3975L8.60168 15.2617C8.54193 15.322 8.47103 15.3707 8.3927 15.4033C8.31445 15.4359 8.23039 15.4521 8.14563 15.4521C8.06088 15.4521 7.97681 15.4359 7.89856 15.4033C7.82023 15.3707 7.74933 15.322 7.68958 15.2617C7.62933 15.202 7.58061 15.1311 7.54797 15.0527C7.51541 14.9745 7.49915 14.8904 7.49915 14.8057C7.49915 14.7209 7.51543 14.6368 7.54797 14.5586C7.58061 14.4803 7.62933 14.4094 7.68958 14.3496V14.3486L10.5529 11.4912L10.5695 11.4746L10.5529 11.459L7.68958 8.60059C7.56854 8.47954 7.50015 8.31572 7.50012 8.14453C7.50012 7.97331 7.56852 7.80857 7.68958 7.6875C7.81059 7.56669 7.97463 7.49902 8.14563 7.49902C8.31663 7.49903 8.48068 7.56668 8.60168 7.6875L11.4591 10.5518L11.4757 10.5684L11.4923 10.5518L14.3497 7.6875C14.4707 7.56668 14.6348 7.49903 14.8058 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.canceled}</div>
			</li>
		</ul>

		<ul class="tpt-order-process__list tpt-order-process__list--returned">
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			
			<li class="tpt-order-process__dot tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#D01345"/>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"/>
					<path d="M14.8058 7.49902C14.9768 7.49902 15.1408 7.56669 15.2618 7.6875C15.3829 7.80857 15.4513 7.97331 15.4513 8.14453C15.4513 8.31572 15.3829 8.47954 15.2618 8.60059L12.3986 11.459L12.382 11.4746L12.3986 11.4912L15.2618 14.3486V14.3496C15.3221 14.4094 15.3708 14.4803 15.4034 14.5586C15.436 14.6368 15.4523 14.7209 15.4523 14.8057C15.4523 14.8904 15.436 14.9745 15.4034 15.0527C15.3708 15.1311 15.3221 15.202 15.2618 15.2617C15.2021 15.322 15.1312 15.3707 15.0529 15.4033C14.9746 15.4359 14.8905 15.4521 14.8058 15.4521C14.721 15.4521 14.637 15.4359 14.5587 15.4033C14.4804 15.3707 14.4095 15.322 14.3497 15.2617L11.4923 12.3975L11.4757 12.3809L11.4591 12.3975L8.60168 15.2617C8.54193 15.322 8.47103 15.3707 8.3927 15.4033C8.31445 15.4359 8.23039 15.4521 8.14563 15.4521C8.06088 15.4521 7.97681 15.4359 7.89856 15.4033C7.82023 15.3707 7.74933 15.322 7.68958 15.2617C7.62933 15.202 7.58061 15.1311 7.54797 15.0527C7.51541 14.9745 7.49915 14.8904 7.49915 14.8057C7.49915 14.7209 7.51543 14.6368 7.54797 14.5586C7.58061 14.4803 7.62933 14.4094 7.68958 14.3496V14.3486L10.5529 11.4912L10.5695 11.4746L10.5529 11.459L7.68958 8.60059C7.56854 8.47954 7.50015 8.31572 7.50012 8.14453C7.50012 7.97331 7.56852 7.80857 7.68958 7.6875C7.81059 7.56669 7.97463 7.49902 8.14563 7.49902C8.31663 7.49903 8.48068 7.56668 8.60168 7.6875L11.4591 10.5518L11.4757 10.5684L11.4923 10.5518L14.3497 7.6875C14.4707 7.56668 14.6348 7.49903 14.8058 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.canceled}</div>
			</li>


			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g opacity="0.4">
					<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
					<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
					</g>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.refunded}</div>
			</li>
		</ul>

		<ul class="tpt-order-process__list tpt-order-process__list--refunded">
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#D01345"/>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"/>
					<path d="M14.8058 7.49902C14.9768 7.49902 15.1408 7.56669 15.2618 7.6875C15.3829 7.80857 15.4513 7.97331 15.4513 8.14453C15.4513 8.31572 15.3829 8.47954 15.2618 8.60059L12.3986 11.459L12.382 11.4746L12.3986 11.4912L15.2618 14.3486V14.3496C15.3221 14.4094 15.3708 14.4803 15.4034 14.5586C15.436 14.6368 15.4523 14.7209 15.4523 14.8057C15.4523 14.8904 15.436 14.9745 15.4034 15.0527C15.3708 15.1311 15.3221 15.202 15.2618 15.2617C15.2021 15.322 15.1312 15.3707 15.0529 15.4033C14.9746 15.4359 14.8905 15.4521 14.8058 15.4521C14.721 15.4521 14.637 15.4359 14.5587 15.4033C14.4804 15.3707 14.4095 15.322 14.3497 15.2617L11.4923 12.3975L11.4757 12.3809L11.4591 12.3975L8.60168 15.2617C8.54193 15.322 8.47103 15.3707 8.3927 15.4033C8.31445 15.4359 8.23039 15.4521 8.14563 15.4521C8.06088 15.4521 7.97681 15.4359 7.89856 15.4033C7.82023 15.3707 7.74933 15.322 7.68958 15.2617C7.62933 15.202 7.58061 15.1311 7.54797 15.0527C7.51541 14.9745 7.49915 14.8904 7.49915 14.8057C7.49915 14.7209 7.51543 14.6368 7.54797 14.5586C7.58061 14.4803 7.62933 14.4094 7.68958 14.3496V14.3486L10.5529 11.4912L10.5695 11.4746L10.5529 11.459L7.68958 8.60059C7.56854 8.47954 7.50015 8.31572 7.50012 8.14453C7.50012 7.97331 7.56852 7.80857 7.68958 7.6875C7.81059 7.56669 7.97463 7.49902 8.14563 7.49902C8.31663 7.49903 8.48068 7.56668 8.60168 7.6875L11.4591 10.5518L11.4757 10.5684L11.4923 10.5518L14.3497 7.6875C14.4707 7.56668 14.6348 7.49903 14.8058 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.canceled}</div>
			</li>


			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.refunded}</div>
			</li>
		</ul>
	</div>
</div>
`;

const PRODUCT_HTML_CANCELED_GROUP = `
<div class="tpt-order-tracker__item-detail">
	${REFUND_LABEL}

	<div class="tpt-order-tracker__products">
		__PRODUCTS__
	</div>

	<div class="tpt-order-process">
		<ul class="tpt-order-process__list tpt-order-process__list-default">
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			
			<li class="tpt-order-process__dot tpt-order-process__dot--canceled tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#D01345"/>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"/>
					<path d="M14.8058 7.49902C14.9768 7.49902 15.1408 7.56669 15.2618 7.6875C15.3829 7.80857 15.4513 7.97331 15.4513 8.14453C15.4513 8.31572 15.3829 8.47954 15.2618 8.60059L12.3986 11.459L12.382 11.4746L12.3986 11.4912L15.2618 14.3486V14.3496C15.3221 14.4094 15.3708 14.4803 15.4034 14.5586C15.436 14.6368 15.4523 14.7209 15.4523 14.8057C15.4523 14.8904 15.436 14.9745 15.4034 15.0527C15.3708 15.1311 15.3221 15.202 15.2618 15.2617C15.2021 15.322 15.1312 15.3707 15.0529 15.4033C14.9746 15.4359 14.8905 15.4521 14.8058 15.4521C14.721 15.4521 14.637 15.4359 14.5587 15.4033C14.4804 15.3707 14.4095 15.322 14.3497 15.2617L11.4923 12.3975L11.4757 12.3809L11.4591 12.3975L8.60168 15.2617C8.54193 15.322 8.47103 15.3707 8.3927 15.4033C8.31445 15.4359 8.23039 15.4521 8.14563 15.4521C8.06088 15.4521 7.97681 15.4359 7.89856 15.4033C7.82023 15.3707 7.74933 15.322 7.68958 15.2617C7.62933 15.202 7.58061 15.1311 7.54797 15.0527C7.51541 14.9745 7.49915 14.8904 7.49915 14.8057C7.49915 14.7209 7.51543 14.6368 7.54797 14.5586C7.58061 14.4803 7.62933 14.4094 7.68958 14.3496V14.3486L10.5529 11.4912L10.5695 11.4746L10.5529 11.459L7.68958 8.60059C7.56854 8.47954 7.50015 8.31572 7.50012 8.14453C7.50012 7.97331 7.56852 7.80857 7.68958 7.6875C7.81059 7.56669 7.97463 7.49902 8.14563 7.49902C8.31663 7.49903 8.48068 7.56668 8.60168 7.6875L11.4591 10.5518L11.4757 10.5684L11.4923 10.5518L14.3497 7.6875C14.4707 7.56668 14.6348 7.49903 14.8058 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.canceled}</div>
			</li>
		</ul>

		<ul class="tpt-order-process__list tpt-order-process__list--returned">
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			
			<li class="tpt-order-process__dot tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#D01345"/>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"/>
					<path d="M14.8058 7.49902C14.9768 7.49902 15.1408 7.56669 15.2618 7.6875C15.3829 7.80857 15.4513 7.97331 15.4513 8.14453C15.4513 8.31572 15.3829 8.47954 15.2618 8.60059L12.3986 11.459L12.382 11.4746L12.3986 11.4912L15.2618 14.3486V14.3496C15.3221 14.4094 15.3708 14.4803 15.4034 14.5586C15.436 14.6368 15.4523 14.7209 15.4523 14.8057C15.4523 14.8904 15.436 14.9745 15.4034 15.0527C15.3708 15.1311 15.3221 15.202 15.2618 15.2617C15.2021 15.322 15.1312 15.3707 15.0529 15.4033C14.9746 15.4359 14.8905 15.4521 14.8058 15.4521C14.721 15.4521 14.637 15.4359 14.5587 15.4033C14.4804 15.3707 14.4095 15.322 14.3497 15.2617L11.4923 12.3975L11.4757 12.3809L11.4591 12.3975L8.60168 15.2617C8.54193 15.322 8.47103 15.3707 8.3927 15.4033C8.31445 15.4359 8.23039 15.4521 8.14563 15.4521C8.06088 15.4521 7.97681 15.4359 7.89856 15.4033C7.82023 15.3707 7.74933 15.322 7.68958 15.2617C7.62933 15.202 7.58061 15.1311 7.54797 15.0527C7.51541 14.9745 7.49915 14.8904 7.49915 14.8057C7.49915 14.7209 7.51543 14.6368 7.54797 14.5586C7.58061 14.4803 7.62933 14.4094 7.68958 14.3496V14.3486L10.5529 11.4912L10.5695 11.4746L10.5529 11.459L7.68958 8.60059C7.56854 8.47954 7.50015 8.31572 7.50012 8.14453C7.50012 7.97331 7.56852 7.80857 7.68958 7.6875C7.81059 7.56669 7.97463 7.49902 8.14563 7.49902C8.31663 7.49903 8.48068 7.56668 8.60168 7.6875L11.4591 10.5518L11.4757 10.5684L11.4923 10.5518L14.3497 7.6875C14.4707 7.56668 14.6348 7.49903 14.8058 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.canceled}</div>
			</li>


			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g opacity="0.4">
					<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
					<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
					</g>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.refunded}</div>
			</li>
		</ul>

		<ul class="tpt-order-process__list tpt-order-process__list--refunded">
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#D01345"/>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"/>
					<path d="M14.8058 7.49902C14.9768 7.49902 15.1408 7.56669 15.2618 7.6875C15.3829 7.80857 15.4513 7.97331 15.4513 8.14453C15.4513 8.31572 15.3829 8.47954 15.2618 8.60059L12.3986 11.459L12.382 11.4746L12.3986 11.4912L15.2618 14.3486V14.3496C15.3221 14.4094 15.3708 14.4803 15.4034 14.5586C15.436 14.6368 15.4523 14.7209 15.4523 14.8057C15.4523 14.8904 15.436 14.9745 15.4034 15.0527C15.3708 15.1311 15.3221 15.202 15.2618 15.2617C15.2021 15.322 15.1312 15.3707 15.0529 15.4033C14.9746 15.4359 14.8905 15.4521 14.8058 15.4521C14.721 15.4521 14.637 15.4359 14.5587 15.4033C14.4804 15.3707 14.4095 15.322 14.3497 15.2617L11.4923 12.3975L11.4757 12.3809L11.4591 12.3975L8.60168 15.2617C8.54193 15.322 8.47103 15.3707 8.3927 15.4033C8.31445 15.4359 8.23039 15.4521 8.14563 15.4521C8.06088 15.4521 7.97681 15.4359 7.89856 15.4033C7.82023 15.3707 7.74933 15.322 7.68958 15.2617C7.62933 15.202 7.58061 15.1311 7.54797 15.0527C7.51541 14.9745 7.49915 14.8904 7.49915 14.8057C7.49915 14.7209 7.51543 14.6368 7.54797 14.5586C7.58061 14.4803 7.62933 14.4094 7.68958 14.3496V14.3486L10.5529 11.4912L10.5695 11.4746L10.5529 11.459L7.68958 8.60059C7.56854 8.47954 7.50015 8.31572 7.50012 8.14453C7.50012 7.97331 7.56852 7.80857 7.68958 7.6875C7.81059 7.56669 7.97463 7.49902 8.14563 7.49902C8.31663 7.49903 8.48068 7.56668 8.60168 7.6875L11.4591 10.5518L11.4757 10.5684L11.4923 10.5518L14.3497 7.6875C14.4707 7.56668 14.6348 7.49903 14.8058 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.canceled}</div>
			</li>


			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.refunded}</div>
			</li>
		</ul>
	</div>
</div>
`;

const PRODUCT_HTML_FAILED_GROUP = `
<div class="tpt-order-tracker__item-detail">
	${REFUND_LABEL}

	<div class="tpt-order-tracker__products">
		__PRODUCTS__
	</div>

	<div class="tpt-order-process">
		<ul class="tpt-order-process__list tpt-order-process__list-default">
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			
			<li class="tpt-order-process__dot tpt-order-process__dot--canceled tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#D01345"/>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"/>
					<path d="M14.8058 7.49902C14.9768 7.49902 15.1408 7.56669 15.2618 7.6875C15.3829 7.80857 15.4513 7.97331 15.4513 8.14453C15.4513 8.31572 15.3829 8.47954 15.2618 8.60059L12.3986 11.459L12.382 11.4746L12.3986 11.4912L15.2618 14.3486V14.3496C15.3221 14.4094 15.3708 14.4803 15.4034 14.5586C15.436 14.6368 15.4523 14.7209 15.4523 14.8057C15.4523 14.8904 15.436 14.9745 15.4034 15.0527C15.3708 15.1311 15.3221 15.202 15.2618 15.2617C15.2021 15.322 15.1312 15.3707 15.0529 15.4033C14.9746 15.4359 14.8905 15.4521 14.8058 15.4521C14.721 15.4521 14.637 15.4359 14.5587 15.4033C14.4804 15.3707 14.4095 15.322 14.3497 15.2617L11.4923 12.3975L11.4757 12.3809L11.4591 12.3975L8.60168 15.2617C8.54193 15.322 8.47103 15.3707 8.3927 15.4033C8.31445 15.4359 8.23039 15.4521 8.14563 15.4521C8.06088 15.4521 7.97681 15.4359 7.89856 15.4033C7.82023 15.3707 7.74933 15.322 7.68958 15.2617C7.62933 15.202 7.58061 15.1311 7.54797 15.0527C7.51541 14.9745 7.49915 14.8904 7.49915 14.8057C7.49915 14.7209 7.51543 14.6368 7.54797 14.5586C7.58061 14.4803 7.62933 14.4094 7.68958 14.3496V14.3486L10.5529 11.4912L10.5695 11.4746L10.5529 11.459L7.68958 8.60059C7.56854 8.47954 7.50015 8.31572 7.50012 8.14453C7.50012 7.97331 7.56852 7.80857 7.68958 7.6875C7.81059 7.56669 7.97463 7.49902 8.14563 7.49902C8.31663 7.49903 8.48068 7.56668 8.60168 7.6875L11.4591 10.5518L11.4757 10.5684L11.4923 10.5518L14.3497 7.6875C14.4707 7.56668 14.6348 7.49903 14.8058 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.failed_delivery}</div>
			</li>

			<li class="tpt-order-process__dash"></li>

			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g opacity="0.4">
					<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
					<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
					</g>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.returned}</div>
			</li>
		</ul>

		<ul class="tpt-order-process__list tpt-order-process__list--returned">
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			
			<li class="tpt-order-process__dot tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#D01345"/>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"/>
					<path d="M14.8058 7.49902C14.9768 7.49902 15.1408 7.56669 15.2618 7.6875C15.3829 7.80857 15.4513 7.97331 15.4513 8.14453C15.4513 8.31572 15.3829 8.47954 15.2618 8.60059L12.3986 11.459L12.382 11.4746L12.3986 11.4912L15.2618 14.3486V14.3496C15.3221 14.4094 15.3708 14.4803 15.4034 14.5586C15.436 14.6368 15.4523 14.7209 15.4523 14.8057C15.4523 14.8904 15.436 14.9745 15.4034 15.0527C15.3708 15.1311 15.3221 15.202 15.2618 15.2617C15.2021 15.322 15.1312 15.3707 15.0529 15.4033C14.9746 15.4359 14.8905 15.4521 14.8058 15.4521C14.721 15.4521 14.637 15.4359 14.5587 15.4033C14.4804 15.3707 14.4095 15.322 14.3497 15.2617L11.4923 12.3975L11.4757 12.3809L11.4591 12.3975L8.60168 15.2617C8.54193 15.322 8.47103 15.3707 8.3927 15.4033C8.31445 15.4359 8.23039 15.4521 8.14563 15.4521C8.06088 15.4521 7.97681 15.4359 7.89856 15.4033C7.82023 15.3707 7.74933 15.322 7.68958 15.2617C7.62933 15.202 7.58061 15.1311 7.54797 15.0527C7.51541 14.9745 7.49915 14.8904 7.49915 14.8057C7.49915 14.7209 7.51543 14.6368 7.54797 14.5586C7.58061 14.4803 7.62933 14.4094 7.68958 14.3496V14.3486L10.5529 11.4912L10.5695 11.4746L10.5529 11.459L7.68958 8.60059C7.56854 8.47954 7.50015 8.31572 7.50012 8.14453C7.50012 7.97331 7.56852 7.80857 7.68958 7.6875C7.81059 7.56669 7.97463 7.49902 8.14563 7.49902C8.31663 7.49903 8.48068 7.56668 8.60168 7.6875L11.4591 10.5518L11.4757 10.5684L11.4923 10.5518L14.3497 7.6875C14.4707 7.56668 14.6348 7.49903 14.8058 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.failed_delivery}</div>
			</li>

			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g opacity="0.4">
					<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
					<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
					</g>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.returned}</div>
			</li>


			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g opacity="0.4">
					<circle cx="5.53491" cy="5.53479" r="3.74203" fill="#BDBDBD" stroke="#BDBDBD" stroke-width="0.737864"></circle>
					<circle cx="5.53397" cy="5.53391" r="5.16505" stroke="#BDBDBD" stroke-width="0.737864"></circle>
					</g>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.refunded}</div>
			</li>
		</ul>

		<ul class="tpt-order-process__list tpt-order-process__list--refunded">
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.confirmed}</div>
			</li>


			<li class="tpt-order-process__dash tpt-order-process__dash--dash"></li>

			
			<li class="tpt-order-process__dot">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#D01345"/>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#D01345" stroke-width="1.47573"/>
					<path d="M14.8058 7.49902C14.9768 7.49902 15.1408 7.56669 15.2618 7.6875C15.3829 7.80857 15.4513 7.97331 15.4513 8.14453C15.4513 8.31572 15.3829 8.47954 15.2618 8.60059L12.3986 11.459L12.382 11.4746L12.3986 11.4912L15.2618 14.3486V14.3496C15.3221 14.4094 15.3708 14.4803 15.4034 14.5586C15.436 14.6368 15.4523 14.7209 15.4523 14.8057C15.4523 14.8904 15.436 14.9745 15.4034 15.0527C15.3708 15.1311 15.3221 15.202 15.2618 15.2617C15.2021 15.322 15.1312 15.3707 15.0529 15.4033C14.9746 15.4359 14.8905 15.4521 14.8058 15.4521C14.721 15.4521 14.637 15.4359 14.5587 15.4033C14.4804 15.3707 14.4095 15.322 14.3497 15.2617L11.4923 12.3975L11.4757 12.3809L11.4591 12.3975L8.60168 15.2617C8.54193 15.322 8.47103 15.3707 8.3927 15.4033C8.31445 15.4359 8.23039 15.4521 8.14563 15.4521C8.06088 15.4521 7.97681 15.4359 7.89856 15.4033C7.82023 15.3707 7.74933 15.322 7.68958 15.2617C7.62933 15.202 7.58061 15.1311 7.54797 15.0527C7.51541 14.9745 7.49915 14.8904 7.49915 14.8057C7.49915 14.7209 7.51543 14.6368 7.54797 14.5586C7.58061 14.4803 7.62933 14.4094 7.68958 14.3496V14.3486L10.5529 11.4912L10.5695 11.4746L10.5529 11.459L7.68958 8.60059C7.56854 8.47954 7.50015 8.31572 7.50012 8.14453C7.50012 7.97331 7.56852 7.80857 7.68958 7.6875C7.81059 7.56669 7.97463 7.49902 8.14563 7.49902C8.31663 7.49903 8.48068 7.56668 8.60168 7.6875L11.4591 10.5518L11.4757 10.5684L11.4923 10.5518L14.3497 7.6875C14.4707 7.56668 14.6348 7.49903 14.8058 7.49902Z" fill="white" stroke="#D01345" stroke-width="0.046497"/>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.failed_delivery}</div>
			</li>


			<li class="tpt-order-process__dash"></li>


			<li class="tpt-order-process__dot tpt-order-process__dot--finish">
				<div class="tpt-order-process__dot-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11.8058" cy="11.8055" r="8.85437" fill="#12283E"></circle>
					<circle cx="11.8058" cy="11.8057" r="11.068" stroke="#12283E" stroke-width="1.47573"></circle>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7143 8.42745C17.0743 8.82234 17.0527 9.4405 16.666 9.80815L10.6841 15.4949L6.9209 11.6521C6.54727 11.2706 6.54728 10.652 6.92093 10.2705C7.29457 9.88902 7.90035 9.88903 8.27398 10.2706L10.7316 12.7801L15.3621 8.37813C15.7488 8.01048 16.3542 8.03256 16.7143 8.42745Z" fill="white"></path>
					</svg>
				</div>
				<div class="tpt-order-process__dot-text">${window.tptTrackOrder.refunded}</div>
			</li>
		</ul>
	</div>
</div>
`;

const PRODUCT_ITEM_HTML_DEFAULT = `
<div class="tpt-order-tracker__product-item">
	<div class="tpt-order-tracker__product-image">
		__PRODUCT_IMAGE__
	</div>

	<div class="tpt-order-tracker__product-info">
		<div class="tpt-order-tracker__product-info-title">
			__PRODUCT_TITLE__
		</div>

		<div class="tpt-order-tracker__product-info-variant">
			__PRODUCT_VARIANT__
		</div>
	</div>

	<div class="tpt-order-tracker__product-price">
		__PRODUCT_PRICE__
	</div>
</div>
`;
